import { useState } from "react";
import Logo from "./Logo";
import Form from "./Form";
import PackingList from "./PackingList";
import Stats from "./Stats";

function App() {
  const [items, setItems] = useState([
    { id: 1, description: "Shirt", quantity: 5, packed: false, category: "School" },
    { id: 2, description: "Pants", quantity: 2, packed: false, category: "Holiday" },
    { id: 3, description: "Shampoo", quantity: 2, packed: true , category: "Holiday"},
  ]);

  function handleAddItem(item) {
    setItems((items) => [...items, item]);
  }

  function handleDeleteItem(id) {
    setItems((items) => items.filter((item) => item.id !== id));
  }

  function handleUpdateItem(id) {
    setItems((items) =>
      items.map((item) =>
        item.id === id ? { ...item, packed: !item.packed } : item
      )
    );
  }

  function handleClearItems() {
    if (window.confirm("Clear all items?")) setItems([]);
  }

  return (
    <div className="app">
      <header>
        <Logo />
      </header>

      <Form onAddItem={handleAddItem} />

      <main>
        <PackingList
          items={items}
          onDeleteItem={handleDeleteItem}
          onUpdateItem={handleUpdateItem}
        />
      </main>

      <Stats items={items} onClearItems={handleClearItems} />
    </div>
  );
}

export default App;
